module.exports = __webpack_public_path__ + "img/team_1.ef5cfa1f.jpg";